(function () {
  const selectors = {
    root: "[data-ecida-bundle]",
    option: "[data-ecida-offer]",
    selectors: "[data-ecida-bundle-selectors]",
    selectorRow: "[data-ecida-selector-row]",
    rowWarning: "[data-ecida-selector-warning]",
    select: "[data-ecida-bundle-select]",
    customSelect: "[data-ecida-custom-select]",
    customTrigger: "[data-ecida-custom-trigger]",
    customMenu: "[data-ecida-custom-menu]",
    customOption: "[data-ecida-custom-option]",
    swatch: "[data-ecida-swatch]",
    error: "[data-ecida-bundle-error]",
    saving: "[data-ecida-bundle-saving]",
    submit: '[name="add"]',
    buttonText: ".m-add-to-cart--text",
    formWrapper: ".m-product-form--wrapper",
    quantityInput: ".m-product-form--input, .m-quantity-price-breaks",
    dynamicCheckout: ".m-product-dynamic-checkout",
  };

  function money(cents) {
    if (typeof window.formatMoney === "function" && window.MinimogSettings?.money_format) {
      return window.formatMoney(cents, window.MinimogSettings.money_format);
    }

    const amount = Number(cents || 0) / 100;
    return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(amount);
  }

  function parseCents(value) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function selectedOption(select) {
    return select.options[select.selectedIndex];
  }

  function selectHasValue(select, value) {
    return Array.from(select.options).some((option) => option.value === value);
  }

  let customDropdownListenersReady = false;

  function isPlaceholderOption(option) {
    return !option || !option.value || option.dataset.placeholder === "true";
  }

  function isOptionAvailable(option) {
    return option?.dataset.available === "true";
  }

  function colorLabel(option) {
    const label = option?.dataset.color || option?.textContent?.trim() || "";
    return label.replace(/\s+-\s+nicht verfügbar$/i, "");
  }

  function optionDisplayLabel(option) {
    if (isPlaceholderOption(option)) return "Farbe auswählen";

    const color = colorLabel(option);
    return isOptionAvailable(option) ? color : `${color} - nicht verfügbar`;
  }

  function setCustomDropdownOpen(dropdown, open) {
    const trigger = dropdown?.querySelector(selectors.customTrigger);
    const menu = dropdown?.querySelector(selectors.customMenu);
    if (!dropdown || !trigger || !menu) return;

    dropdown.classList.toggle("is-open", open);
    trigger.setAttribute("aria-expanded", open ? "true" : "false");
    menu.hidden = !open;
  }

  function closeCustomDropdowns(exceptDropdown) {
    document.querySelectorAll(`${selectors.customSelect}.is-open`).forEach((dropdown) => {
      if (dropdown !== exceptDropdown) {
        setCustomDropdownOpen(dropdown, false);
      }
    });
  }

  function customSwatch(option) {
    const swatch = document.createElement("span");
    swatch.className = "ecida-bundle__custom-swatch";

    if (option?.dataset.swatch) {
      swatch.style.backgroundColor = option.dataset.swatch;
    }

    if (!isPlaceholderOption(option) && !isOptionAvailable(option)) {
      swatch.classList.add("is-unavailable");
    }

    swatch.setAttribute("aria-hidden", "true");
    return swatch;
  }

  function syncCustomDropdown(select) {
    const dropdown = select.nextElementSibling?.matches(selectors.customSelect)
      ? select.nextElementSibling
      : select.parentElement?.querySelector(selectors.customSelect);
    const trigger = dropdown?.querySelector(selectors.customTrigger);
    if (!dropdown || !trigger) return;

    const option = selectedOption(select);
    const label = document.createElement("span");
    const arrow = document.createElement("span");
    label.className = "ecida-bundle__custom-label";
    label.textContent = optionDisplayLabel(option);
    arrow.className = "ecida-bundle__custom-arrow";
    arrow.setAttribute("aria-hidden", "true");

    dropdown.classList.toggle("has-placeholder", isPlaceholderOption(option));
    dropdown.classList.toggle("is-unavailable", !isPlaceholderOption(option) && !isOptionAvailable(option));
    trigger.replaceChildren(customSwatch(option), label, arrow);

    dropdown.querySelectorAll(selectors.customOption).forEach((button) => {
      const isSelected = button.dataset.ecidaCustomOption === select.value;
      button.classList.toggle("is-selected", isSelected);
      button.setAttribute("aria-selected", isSelected ? "true" : "false");
    });
  }

  function buildCustomDropdown(bundle, select) {
    if (select.nextElementSibling?.matches(selectors.customSelect)) {
      syncCustomDropdown(select);
      return;
    }

    const dropdown = document.createElement("div");
    const trigger = document.createElement("button");
    const menu = document.createElement("div");

    dropdown.className = "ecida-bundle__custom-select";
    dropdown.dataset.ecidaCustomSelect = "";

    trigger.type = "button";
    trigger.className = "ecida-bundle__custom-trigger";
    trigger.dataset.ecidaCustomTrigger = "";
    trigger.setAttribute("aria-label", select.getAttribute("aria-label") || "Farbe auswählen");
    trigger.setAttribute("aria-haspopup", "listbox");
    trigger.setAttribute("aria-expanded", "false");

    menu.className = "ecida-bundle__custom-menu";
    menu.dataset.ecidaCustomMenu = "";
    menu.setAttribute("role", "listbox");
    menu.hidden = true;

    Array.from(select.options).forEach((option) => {
      if (isPlaceholderOption(option)) return;

      const item = document.createElement("button");
      const label = document.createElement("span");
      const unavailable = !isOptionAvailable(option);

      item.type = "button";
      item.className = "ecida-bundle__custom-option";
      item.dataset.ecidaCustomOption = option.value;
      item.dataset.available = option.dataset.available || "false";
      item.setAttribute("role", "option");
      item.setAttribute("aria-disabled", unavailable ? "true" : "false");
      item.disabled = option.disabled || unavailable;
      item.classList.toggle("is-unavailable", unavailable);

      label.className = "ecida-bundle__custom-option-label";
      label.textContent = optionDisplayLabel(option);

      item.replaceChildren(customSwatch(option), label);
      item.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (item.disabled) return;

        select.value = option.value;
        select.dispatchEvent(new Event("change", { bubbles: true }));
        setCustomDropdownOpen(dropdown, false);
      });

      menu.appendChild(item);
    });

    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      const willOpen = !dropdown.classList.contains("is-open");
      closeCustomDropdowns(dropdown);
      setCustomDropdownOpen(dropdown, willOpen);
    });

    dropdown.addEventListener("click", (event) => event.stopPropagation());
    dropdown.replaceChildren(trigger, menu);
    select.insertAdjacentElement("afterend", dropdown);
    syncCustomDropdown(select);
  }

  function ensureCustomDropdownListeners() {
    if (customDropdownListenersReady) return;
    customDropdownListenersReady = true;

    document.addEventListener("click", () => closeCustomDropdowns());
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeCustomDropdowns();
      }
    });
  }

  function enhanceCustomDropdowns(bundle) {
    bundle.classList.add("is-enhanced");
    ensureCustomDropdownListeners();
    bundle.querySelectorAll(selectors.select).forEach((select) => buildCustomDropdown(bundle, select));
  }

  function syncCustomDropdowns(bundle) {
    bundle.querySelectorAll(selectors.select).forEach(syncCustomDropdown);
  }

  function offerData(optionButton) {
    return {
      type: optionButton?.dataset.ecidaOffer || "single",
      paidQty: Number(optionButton?.dataset.paidQty || 1),
      freeQty: Number(optionButton?.dataset.freeQty || 0),
      totalQty: Number(optionButton?.dataset.totalQty || 1),
      label: optionButton?.dataset.bundleLabel || "ECIDA Bundle",
    };
  }

  function storageKey(bundle) {
    return `ecida-bundle:${bundle.dataset.bundleGroup || bundle.dataset.bundleProduct || window.location.pathname}`;
  }

  function storageKeys(bundle) {
    const keys = new Set([storageKey(bundle)]);

    if (bundle.dataset.bundleProduct) {
      keys.add(`ecida-bundle:${bundle.dataset.bundleProduct}`);
    }

    if (bundle.dataset.bundleTitle) {
      keys.add(`ecida-bundle-title:${bundle.dataset.bundleTitle}`);
    }

    (bundle.dataset.bundleHandles || "")
      .split(",")
      .map((handle) => handle.trim())
      .filter(Boolean)
      .forEach((handle) => keys.add(`ecida-bundle:${handle}`));

    return Array.from(keys);
  }

  function readSavedState(bundle) {
    try {
      let latestState = null;

      for (const key of storageKeys(bundle)) {
        const rawState = window.sessionStorage.getItem(key);
        if (!rawState) continue;

        const state = JSON.parse(rawState);
        if (!latestState || Number(state.updatedAt || 0) > Number(latestState.updatedAt || 0)) {
          latestState = state;
        }
      }

      return latestState;
    } catch (error) {
      return null;
    }
  }

  function saveState(bundle) {
    const activeOffer = getActiveOffer(bundle);
    const selections = Array.from(bundle.querySelectorAll(selectors.select)).map((select) => select.value || "");
    const colorsLocked = bundle.dataset.ecidaColorsLocked === "true";

    try {
      const payload = JSON.stringify({
        offer: {
          paidQty: activeOffer.paidQty,
          freeQty: activeOffer.freeQty,
          totalQty: activeOffer.totalQty,
        },
        selections,
        colorsLocked,
        updatedAt: Date.now(),
      });

      storageKeys(bundle).forEach((key) => window.sessionStorage.setItem(key, payload));
    } catch (error) {
      // Storage can be unavailable in private modes; the bundle still works without persistence.
    }
  }

  function restoreState(bundle) {
    const state = readSavedState(bundle);
    if (!state || !Array.isArray(state.selections)) return false;
    const colorsLocked =
      state.colorsLocked === true ||
      state.selections.some((value, index) => Boolean(value) && (index > 0 || state.manualFirstSelection === true));

    const savedOffer = state.offer || {};
    const offerButton = bundle.querySelector(
      `${selectors.option}[data-paid-qty="${savedOffer.paidQty}"][data-free-qty="${savedOffer.freeQty}"][data-total-qty="${savedOffer.totalQty}"]`
    );

    if (offerButton) {
      setActiveOffer(bundle, offerButton, false);
    }

    bundle.querySelectorAll(selectors.select).forEach((select, index) => {
      if (index === 0 && !colorsLocked) return;

      const savedValue = state.selections[index];
      if (savedValue && selectHasValue(select, savedValue)) {
        select.value = savedValue;
      }
    });

    bundle.dataset.ecidaColorsLocked = colorsLocked ? "true" : "false";

    syncSwatches(bundle);
    syncCustomDropdowns(bundle);
    updatePrices(bundle);
    syncFormState(bundle);
    return true;
  }

  function getActiveOffer(bundle) {
    return offerData(bundle.querySelector(`${selectors.option}.is-selected`));
  }

  function getFirstSelectedVariant(bundle) {
    const select = bundle.querySelector(selectors.select);
    return select ? selectedOption(select) : null;
  }

  function isSingleOfferAvailable(bundle) {
    const variant = getFirstSelectedVariant(bundle);
    return !isPlaceholderOption(variant) && isOptionAvailable(variant);
  }

  function setError(bundle, message) {
    const error = bundle.querySelector(selectors.error);
    if (!error) return;

    if (message) {
      error.textContent = message;
      error.hidden = false;
    } else {
      error.textContent = "";
      error.hidden = true;
    }
  }

  function visibleSelectorRows(bundle) {
    return Array.from(bundle.querySelectorAll(selectors.selectorRow)).filter((row) => !row.hidden);
  }

  function activeOfferButton(bundle) {
    return bundle.querySelector(`${selectors.option}.is-selected`);
  }

  function selectedVariantCounts(bundle) {
    const counts = new Map();
    visibleSelectorRows(bundle).forEach((row) => {
      const select = row.querySelector(selectors.select);
      if (!select) return;

      const option = selectedOption(select);
      if (!option || !option.value) return;
      const current = counts.get(option.value) || { option, quantity: 0 };
      current.quantity += 1;
      counts.set(option.value, current);
    });
    return counts;
  }

  function syncRowWarnings(bundle) {
    bundle.querySelectorAll(selectors.rowWarning).forEach((warning) => {
      warning.textContent = "";
      warning.hidden = true;
    });

    visibleSelectorRows(bundle).forEach((row) => {
      const select = row.querySelector(selectors.select);
      const option = select ? selectedOption(select) : null;
      const warning = row.nextElementSibling?.matches(selectors.rowWarning) ? row.nextElementSibling : null;
      if (!option || !option.value || !warning || option.dataset.available === "true") return;

      const color = option.dataset.color || option.textContent.trim();
      warning.textContent = `${color} ist aktuell nicht verfügbar und kann nicht zum Paket hinzugefügt werden. Bitte wähle eine verfügbare Farbe.`;
      warning.hidden = false;
    });
  }

  function validateInventory(bundle, showErrors = true) {
    const activeOffer = getActiveOffer(bundle);
    if (activeOffer.type !== "bundle") return true;

    const hasMissingSelection = visibleSelectorRows(bundle).some((row) => {
      const select = row.querySelector(selectors.select);
      return !select || !select.value;
    });

    if (hasMissingSelection) {
      if (showErrors) {
        setError(bundle, "Bitte wähle für alle Plätze eine Farbe aus.");
      }
      return false;
    }

    for (const { option, quantity } of selectedVariantCounts(bundle).values()) {
      const isAvailable = option.dataset.available === "true";
      const inventoryManagement = option.dataset.inventoryManagement;
      const inventoryPolicy = option.dataset.inventoryPolicy;
      const inventoryQuantity = Number(option.dataset.inventoryQuantity || 0);
      const color = option.dataset.color || option.textContent.trim();

      if (!isAvailable) {
        if (showErrors) {
          setError(bundle, `${color} ist aktuell nicht verfügbar. Bitte wähle eine andere Farbe.`);
        }
        return false;
      }

      if (inventoryManagement && inventoryPolicy !== "continue" && inventoryQuantity < quantity) {
        if (showErrors) {
          setError(
            bundle,
            `Wir haben von ${color} nur noch ${inventoryQuantity} auf Lager. Bitte wähle eine andere Farbe oder ein kleineres Paket.`
          );
        }
        return false;
      }
    }

    setError(bundle, "");
    return true;
  }

  function syncSwatches(bundle) {
    bundle.querySelectorAll(".ecida-bundle__selector-row").forEach((row) => {
      const select = row.querySelector(selectors.select);
      const swatch = row.querySelector(selectors.swatch);
      const option = select ? selectedOption(select) : null;

      if (swatch && option?.dataset.swatch) {
        swatch.style.backgroundColor = option.dataset.swatch;
      } else if (swatch) {
        swatch.style.backgroundColor = "#f3eee9";
      }
    });
  }

  function updatePrices(bundle) {
    const variant = getFirstSelectedVariant(bundle);
    if (!variant) return;

    const price = parseCents(variant.dataset.price);
    const comparePrice = Math.max(parseCents(variant.dataset.comparePrice), price);

    bundle.querySelectorAll(selectors.option).forEach((button) => {
      const offer = offerData(button);
      const paidTotal = price * offer.paidQty;
      const compareTotal = comparePrice * offer.totalQty;
      const effectiveEach = offer.totalQty > 0 ? Math.round(paidTotal / offer.totalQty) : price;
      const eachPrice = button.querySelector("[data-ecida-each-price]");

      button.querySelector("[data-ecida-price]")?.replaceChildren(document.createTextNode(money(paidTotal)));
      button.querySelector("[data-ecida-compare]")?.replaceChildren(document.createTextNode(money(compareTotal)));

      if (eachPrice && eachPrice.dataset.ecidaCustomBadge !== "true") {
        eachPrice.replaceChildren(document.createTextNode(`${money(effectiveEach)} pro Stück`));
      }
    });

    const saving = bundle.querySelector(selectors.saving);
    if (saving) {
      saving.textContent = "";
      saving.hidden = true;
    }
  }

  function syncSelectorRows(bundle) {
    const activeOffer = getActiveOffer(bundle);
    const isBundle = activeOffer.type === "bundle";
    const selectorsWrapper = bundle.querySelector(selectors.selectors);
    const selectedButton = activeOfferButton(bundle);

    if (isBundle && selectorsWrapper && selectedButton) {
      selectedButton.insertAdjacentElement("afterend", selectorsWrapper);
    }

    bundle.querySelectorAll(selectors.selectorRow).forEach((row, index) => {
      row.hidden = !isBundle || index >= activeOffer.totalQty;
    });

    bundle.querySelectorAll(selectors.rowWarning).forEach((warning, index) => {
      warning.hidden = !isBundle || index >= activeOffer.totalQty || warning.textContent === "";
    });
  }

  function syncCtaPlacement(bundle) {
    const form = bundle.closest("form");
    const activeOffer = getActiveOffer(bundle);
    const isBundle = activeOffer.type === "bundle";
    const formWrapper = form?.querySelector(selectors.formWrapper);
    const selectedButton = activeOfferButton(bundle);
    const selectorsWrapper = bundle.querySelector(selectors.selectors);
    const saving = bundle.querySelector(selectors.saving);

    if (!formWrapper || !selectedButton) return;

    formWrapper.classList.add("ecida-bundle__form-wrapper");

    if (isBundle && selectorsWrapper && !selectorsWrapper.hidden) {
      if (saving && saving.parentElement === selectorsWrapper) {
        saving.insertAdjacentElement("beforebegin", formWrapper);
      } else {
        selectorsWrapper.appendChild(formWrapper);
      }
    } else {
      selectedButton.insertAdjacentElement("afterend", formWrapper);
    }
  }

  function syncFormState(bundle) {
    const form = bundle.closest("form");
    const activeOffer = getActiveOffer(bundle);
    const isBundle = activeOffer.type === "bundle";
    const selectorsWrapper = bundle.querySelector(selectors.selectors);
    const quantityInputs = form ? form.querySelectorAll(selectors.quantityInput) : [];
    const dynamicCheckout = form?.querySelector(selectors.dynamicCheckout);
    const submit = form?.querySelector(selectors.submit);
    const buttonText = submit?.querySelector(selectors.buttonText);
    const saving = bundle.querySelector(selectors.saving);
    syncSelectorRows(bundle);
    const isValid = validateInventory(bundle, false);
    const isSingleUnavailable = !isBundle && !isSingleOfferAvailable(bundle);

    if (selectorsWrapper) selectorsWrapper.hidden = !isBundle;
    if (saving) saving.hidden = true;
    quantityInputs.forEach((quantityInput) => {
      quantityInput.hidden = isBundle;
    });
    if (dynamicCheckout) dynamicCheckout.hidden = isBundle;
    syncRowWarnings(bundle);
    syncCustomDropdowns(bundle);
    syncCtaPlacement(bundle);

    if (buttonText && !buttonText.dataset.ecidaOriginalText) {
      buttonText.dataset.ecidaOriginalText = buttonText.textContent.trim();
    }

    if (buttonText) {
      buttonText.textContent = isBundle ? "Paket in den Warenkorb" : buttonText.dataset.ecidaOriginalText;
    }

    if (submit) {
      if (isBundle && !isValid) {
        submit.disabled = true;
        submit.setAttribute("aria-disabled", "true");
        submit.dataset.ecidaBundleDisabled = "true";
      } else if (isSingleUnavailable) {
        submit.disabled = true;
        submit.setAttribute("aria-disabled", "true");
        submit.dataset.ecidaSingleDisabled = "true";
      } else if (submit.dataset.ecidaBundleDisabled === "true" || submit.dataset.ecidaSingleDisabled === "true") {
        submit.disabled = false;
        submit.removeAttribute("aria-disabled");
        delete submit.dataset.ecidaBundleDisabled;
        delete submit.dataset.ecidaSingleDisabled;
      }
    }
  }

  function setActiveOffer(bundle, selectedButton, persist = true) {
    bundle.querySelectorAll(selectors.option).forEach((button) => {
      const isSelected = button === selectedButton;
      button.classList.toggle("is-selected", isSelected);
      button.setAttribute("aria-checked", isSelected ? "true" : "false");
    });

    updatePrices(bundle);
    syncFormState(bundle);

    if (persist) {
      saveState(bundle);
    }
  }

  function buildCartItems(bundle) {
    const activeOffer = getActiveOffer(bundle);

    return Array.from(selectedVariantCounts(bundle), ([id, item]) => ({
      id: Number(id),
      quantity: item.quantity,
      properties: {
        _ecida_bundle: bundle.dataset.bundleProduct || "ecida-bundle",
        _ecida_bundle_label: activeOffer.label,
      },
    }));
  }

  function toggleLoading(button, loading) {
    if (!button) return;
    button.classList.toggle("m-spinner-loading", loading);
    button.disabled = loading;
  }

  function showCartSuccess(target, response, firstVariantId) {
    const { MinimogSettings, MinimogStrings, MinimogTheme, MinimogEvents } = window;
    const cartDrawer = document.querySelector("m-cart-drawer");

    if (MinimogSettings?.use_ajax_atc) {
      if (cartDrawer && MinimogSettings.enable_cart_drawer) {
        MinimogTheme?.Notification?.show({
          target: cartDrawer.querySelector("m-cart-items"),
          method: "prepend",
          type: "success",
          message: MinimogStrings?.itemAdded || "Hinzugefügt",
          delay: 400,
        });
        cartDrawer.open();
      } else {
        MinimogTheme?.Notification?.show({
          target,
          method: "appendChild",
          type: "success",
          message: MinimogStrings?.itemAdded || "Hinzugefügt",
          last: 3000,
        });
      }

      MinimogEvents?.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: response, productVariantId: firstVariantId });
      document.dispatchEvent(new CustomEvent("product-ajax:added", { detail: { product: response } }));
      return;
    }

    window.location = MinimogSettings?.routes?.cart || "/cart";
  }

  function addBundleToCart(bundle, event) {
    const form = bundle.closest("form");
    const submit = form?.querySelector(selectors.submit);
    const errorTarget = bundle.querySelector(selectors.error) || form;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!validateInventory(bundle, true)) return;

    const items = buildCartItems(bundle);
    if (!items.length) {
      setError(bundle, "Bitte wähle zuerst eine Farbe aus.");
      return;
    }

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const config = typeof fetchConfig === "function" ? fetchConfig("javascript") : { method: "POST", headers: {} };
    config.method = "POST";
    config.headers = {
      ...config.headers,
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/json",
    };
    config.body = JSON.stringify({
      items,
      sections: sectionsToBundle,
      sections_url: window.location.pathname,
    });

    toggleLoading(submit, true);

    fetch(window.MinimogSettings.routes.cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          setError(bundle, response.description || response.message || "Das Paket konnte nicht hinzugefügt werden.");
          document.dispatchEvent(
            new CustomEvent("product-ajax:error", {
              detail: { errorMessage: response.description || response.message },
            })
          );
          return;
        }

        setError(bundle, "");
        showCartSuccess(errorTarget, response, items[0].id);
      })
      .catch(() => {
        setError(bundle, "Das Paket konnte gerade nicht hinzugefügt werden. Bitte versuche es erneut.");
      })
      .finally(() => {
        toggleLoading(submit, false);
        syncFormState(bundle);
      });
  }

  function initBundle(bundle) {
    if (bundle.dataset.ecidaBundleReady === "true") return;
    bundle.dataset.ecidaBundleReady = "true";

    const form = bundle.closest("form");
    const defaultButton = bundle.querySelector(`${selectors.option}.is-selected`) || bundle.querySelector('[data-ecida-offer="bundle"]') || bundle.querySelector(selectors.option);

    enhanceCustomDropdowns(bundle);

    bundle.querySelectorAll(selectors.option).forEach((button) => {
      button.addEventListener("click", () => setActiveOffer(bundle, button));
    });

    bundle.querySelectorAll(selectors.select).forEach((select) => {
      select.addEventListener("change", () => {
        bundle.dataset.ecidaColorsLocked = "true";
        syncSwatches(bundle);
        syncCustomDropdowns(bundle);
        updatePrices(bundle);
        syncFormState(bundle);
        saveState(bundle);
      });
    });

    form?.addEventListener(
      "submit",
      (event) => {
        if (getActiveOffer(bundle).type === "bundle") {
          addBundleToCart(bundle, event);
        }
      },
      true
    );

    syncSwatches(bundle);
    syncCustomDropdowns(bundle);
    if (defaultButton) setActiveOffer(bundle, defaultButton, false);
    restoreState(bundle);
  }

  function initAll() {
    document.querySelectorAll(selectors.root).forEach(initBundle);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
